import { useId, useState } from "react";

interface TooltipProps {
  /** Tooltip body text. */
  text: string;
  /** Accessible label for the trigger. */
  label?: string;
}

/**
 * Small "i" info trigger that reveals a one-line tooltip on hover and on
 * tap/focus (so it works on touch devices too).
 */
export function Tooltip({ text, label = "More information" }: TooltipProps) {
  const [open, setOpen] = useState(false);
  const id = useId();

  return (
    <span className="tooltip">
      <button
        type="button"
        className="tooltip__trigger"
        aria-label={label}
        aria-describedby={open ? id : undefined}
        aria-expanded={open}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={() => setOpen((v) => !v)}
      >
        i
      </button>
      <span
        id={id}
        role="tooltip"
        className={`tooltip__bubble${open ? " tooltip__bubble--open" : ""}`}
      >
        {text}
      </span>
    </span>
  );
}
